export default function () {
  const widgetName = 'fairEvents';
  const widgetOpts = fairEventsOpts;

  const breakpoint = 1000;
  const isDesktopScreen = $(window).width() >= breakpoint;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: isDesktopScreen ? [] : ['all'],
    itemsPerPanel: 5,
    maxItemsVisible: 5,
    imageIsBackground: true,
    hasImages: true,
    lazyLoadImages: true,
    showDescription: false,
    moreButton: false,
    textOverImage: false,
    buyNowButton: false,

    cardWidgetLoaded: function (data) {
      const widgetData = data.items;

      if (widgetData.length < 1) {
        $(`#${widgetName}`).remove();
      } else {
        $(`#${widgetName}`)
          .append('<div class="events-wrapper"></div>')
          .append('<a href="/events" class="button all-events-btn">view all events</a>');

        customAutoEventFormat(widgetData);
      }
    },
  });

  function customAutoEventFormat(data) {
    const $containerEvents = $(`#${widgetName} .events-wrapper`);
    $(`#${widgetName} .card-widget-item`).each(function (i) {
      const $cardEvent = $(this);
      const {
        DateRange: widgetDate,
        Title: widgetName,
        URL: widgetURL,
        ImageWithPath: widgetImage,
      } = data[i];

      let dateLayout = '';
      if (widgetDate != null) {
        const fixedDate = widgetDate.split('-');
        if (fixedDate.length === 1) {
          const monthStart = formatDate(fixedDate, 0, 0, 0).substring(0, 3);
          const dayStart = formatDate(fixedDate, 0, 0, 1);
          dateLayout = buildEventDateLayout(monthStart, dayStart);
        } else if (fixedDate.length === 2) {
          const monthStart = formatDate(fixedDate, 0, 0, 0).substring(0, 3);
          const dayStart = formatDate(fixedDate, 0, 0, 1);
          const monthEnd = formatDate(fixedDate, 1, 0, 0).substring(0, 3);
          const dayEnd = formatDate(fixedDate, 1, 0, 1);
          dateLayout = buildEventDateLayout(monthStart, dayStart, monthEnd, dayEnd);
        }
      }

      $cardEvent.attr('tabindex', '0');
      $cardEvent
        .empty()
        .append(buildEventInfoLayout(widgetName, widgetImage, widgetURL, widgetDate));
      $cardEvent.find('.event-info').append(dateLayout);
      $cardEvent.appendTo($containerEvents);

      if (!widgetURL) {
        $cardEvent.addClass('void-link').removeAttr('href');
      }
    });
  }

  // ---------------
  function buildEventInfoLayout(title, image, eventUrl, date) {
    const urlAttr = !isLocalUrl(eventUrl) ? 'target="_blank"' : '';
    let infoLayout = `
    <div class="img-container">
      ${eventUrl != null ? `<div class="overlay"><div class="button-container"><a href="${eventUrl}" class="button" ${urlAttr}>More</a></div></div>` : ''}

      <img src="${image}" alt="${title}" class="card-widget-image">
    </div>
    <div class="event-info">
      <span class="event-name ${date == null ? 'manual-feed' : ''}">${title}</span>
    </div>`;

    return infoLayout;
  }

  // ---------------
  function formatDate(date, slot1, slot2, slot3) {
    return date[slot1].trim().split(',')[slot2].trim().split(' ')[slot3].trim();
  }

  // ---------------
  function buildEventDateLayout(
    eventStartMonth,
    eventStartDay,
    eventEndMonth = null,
    eventEndDay = null,
  ) {
    if (!eventEndMonth || !eventEndDay) {
      return `
        <div class="event-date">
          <span class="month">${eventStartMonth}</span>
          <span class="day">${eventStartDay}</span>
        </div>`;
    }

    if (eventStartMonth === eventEndMonth) {
      return `
        <div class="event-date double-date">
          <span class="month">${eventStartMonth}</span>
          <span class="day">${eventStartDay}<span class="separator">-</span>${eventEndDay}</span>
        </div>`;
    }

    return `
      <div class="event-date date-range">
        <div class="combo-date">
          <span class="month">${eventStartMonth}</span>
          <span class="day">${eventStartDay}</span>
        </div>
        <span class="separator-month">-</span>
        <div class="combo-date">
          <span class="month">${eventEndMonth}</span>
          <span class="day">${eventEndDay}</span>
        </div>
      </div>`;
  }
}
export function isLocalUrl(urlToCheck) {
  const clientPath = SITEBASEURL;
  return urlToCheck !== null && urlToCheck.includes(clientPath);
}
